<template>
    <el-container>
        <el-main class="main-container" ref="mainContainer">
            <Main />
        </el-main>
        <el-backtop target=".main-container"></el-backtop>
    </el-container>

</template>
<script>
import Main from "./main.vue"
export default {
    name: 'layout',
    data() {
        return {

        }
    },
    components: {
        Main
    },
    watch: {
        $route() {
            this.$nextTick(() => {
                this.$refs.mainContainer.$el.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                })
            })
        }
    }
}

</script>


<style lang="scss" scoped>
.el-backtop {
    background: #42b35c;
    transition: 0.3s;
}

.el-backtop,
.el-calendar-table td.is-today {
    color: #fff;
}

.el-backtop:hover {
    background: #fff;
}

.el-backtop:hover,
.el-calendar-table td.is-today:hover {
    color: #42b35c;
}

.el-header {
    color: #fff;
}

.el-main {
    background-color: #fff;
    height: 100vh;
    flex-grow: 1;
    padding: 0 !important;
    overflow: auto;
}
</style>